import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    attrs: {
      id: "priceStock"
    }
  }, [_c("a-form-model", {
    ref: "formData",
    staticClass: "form",
    attrs: {
      model: _vm.formData,
      rules: _vm.rules
    }
  }, [_vm.specFlag == 2 ? _c("div", [_c("a-card", {
    staticStyle: {
      "border-top": "24px solid #f0f2f5",
      height: "100%"
    },
    attrs: {
      bordered: false
    }
  }, [_c("a-row", {
    staticStyle: {
      width: "1184px"
    },
    attrs: {
      gutter: 50
    }
  }, [_c("a-col", {
    attrs: {
      span: 8
    }
  }, [_c("a-form-model-item", {
    staticStyle: {
      margin: "0"
    },
    attrs: {
      prop: "productNo",
      label: _vm.$t("productDetail.productNumber")
    }
  }, [_c("a-input", {
    attrs: {
      maxLength: 50,
      disabled: _vm.noEditproductNo,
      allowClear: true,
      placeholder: _vm.$t("public.enterPlease")
    },
    on: {
      change: _vm.onProductNoInput
    },
    model: {
      value: _vm.formData.productNo,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "productNo", $$v);
      },
      expression: "formData.productNo"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 8
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("productDetail.stockNum"),
      prop: "productStocknum"
    }
  }, [_c("a-input-number", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      allowClear: true,
      placeholder: _vm.$t("public.enterPlease"),
      min: 0,
      max: 999999999
    },
    model: {
      value: _vm.formData.productStocknum,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "productStocknum", $$v);
      },
      expression: "formData.productStocknum"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 8
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("productDetail.ERPstockSyncStatus")
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("public.pleaseSelect")
    },
    model: {
      value: _vm.formData.stockSyn,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "stockSyn", $$v);
      },
      expression: "formData.stockSyn"
    }
  }, _vm._l(_vm.stockSyncStatusList, function (item) {
    return _c("a-select-option", {
      key: item.id,
      attrs: {
        value: item.id
      }
    }, [_vm._v(_vm._s(item.name))]);
  }), 1)], 1)], 1), _vm.deliveryChannel == 1 || _vm.deliveryChannel == null || _vm.deliveryChannel == undefined ? _c("a-col", {
    attrs: {
      span: 8
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("productDetail.deliveryChannel"),
      prop: "productChannelid"
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("public.pleaseSelect")
    },
    model: {
      value: _vm.formData.productChannelid,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "productChannelid", $$v);
      },
      expression: "formData.productChannelid"
    }
  }, _vm._l(_vm.productChannelidList, function (item) {
    return _c("a-select-option", {
      key: item.id,
      attrs: {
        value: item.id,
        disabled: item.status != 1
      }
    }, [_vm._v(_vm._s(item.name))]);
  }), 1)], 1)], 1) : _vm._e(), _c("a-col", {
    attrs: {
      span: 8
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("newProducDetail.sellWay"),
      prop: "caseOrItem"
    }
  }, [_c("a-select", {
    attrs: {
      mode: "multiple",
      placeholder: _vm.$t("public.pleaseSelect")
    },
    model: {
      value: _vm.formData.caseOrItem,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "caseOrItem", $$v);
      },
      expression: "formData.caseOrItem"
    }
  }, _vm._l(_vm.caseOrItemList, function (item) {
    return _c("a-select-option", {
      key: item.id,
      attrs: {
        value: item.id
      }
    }, [_vm._v(_vm._s(item.name))]);
  }), 1)], 1)], 1), _c("a-col", {
    attrs: {
      span: 8
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("productDetail.choiceDays"),
      prop: "daysOfStock"
    }
  }, [_c("a-input-number", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      allowClear: true,
      placeholder: _vm.$t("public.enterPlease"),
      max: 999
    },
    model: {
      value: _vm.formData.daysOfStock,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "daysOfStock", $$v);
      },
      expression: "formData.daysOfStock"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 8
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("productDetail.expressWayPrimary"),
      prop: "transportFirstId"
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      placeholder: _vm.$t("public.pleaseSelect")
    },
    model: {
      value: _vm.formData.transportFirstId,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "transportFirstId", $$v);
      },
      expression: "formData.transportFirstId"
    }
  }, _vm._l(_vm.transportList, function (item) {
    return _c("a-select-option", {
      key: item.id,
      attrs: {
        value: item.id
      }
    }, [_vm._v(_vm._s(item.name))]);
  }), 1)], 1)], 1), _c("a-col", {
    attrs: {
      span: 8
    }
  }, [_c("a-form-model-item", {
    key: "source",
    attrs: {
      label: _vm.$t("productDetail.sourceArea")
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      placeholder: _vm.$t("public.pleaseSelect"),
      allowClear: ""
    },
    model: {
      value: _vm.formData.productSourceareaid,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "productSourceareaid", $$v);
      },
      expression: "formData.productSourceareaid"
    }
  }, _vm._l(_vm.sourceareaList, function (item) {
    return _c("a-select-option", {
      key: item.id,
      attrs: {
        value: item.id,
        disabled: item.status != 1
      }
    }, [_vm._v(_vm._s(item.name))]);
  }), 1)], 1)], 1), _c("a-col", {
    attrs: {
      span: 8
    }
  }, [_c("a-form-model-item", {
    key: "bind",
    attrs: {
      label: _vm.$t("productDetail.brand")
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      showSearch: "",
      optionFilterProp: "children",
      placeholder: _vm.$t("public.pleaseSelect"),
      allowClear: ""
    },
    model: {
      value: _vm.formData.productBrandid,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "productBrandid", $$v);
      },
      expression: "formData.productBrandid"
    }
  }, _vm._l(_vm.brandList, function (item) {
    return _c("a-select-option", {
      key: item.id,
      attrs: {
        value: item.id,
        disabled: item.status != 1
      }
    }, [_vm._v(_vm._s(item.name))]);
  }), 1)], 1)], 1), _c("a-col", {
    attrs: {
      span: 8
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("newProducDetail.capacity")
    }
  }, [_c("a-input", {
    attrs: {
      maxLength: 50,
      allowClear: true,
      placeholder: _vm.$t("public.enterPlease")
    },
    model: {
      value: _vm.formData.capacity,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "capacity", $$v);
      },
      expression: "formData.capacity"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 8
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("newProducDetail.minCount")
    }
  }, [_c("a-input-number", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      min: 0,
      allowClear: true,
      placeholder: _vm.$t("public.enterPlease"),
      max: 999999999
    },
    model: {
      value: _vm.formData.minOrderQuantity,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "minOrderQuantity", $$v);
      },
      expression: "formData.minOrderQuantity"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 8
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("newProducDetail.rushu")
    }
  }, [_c("a-input", {
    attrs: {
      maxLength: 50,
      allowClear: true,
      placeholder: _vm.$t("public.enterPlease")
    },
    model: {
      value: _vm.formData.caseQuantity,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "caseQuantity", $$v);
      },
      expression: "formData.caseQuantity"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 8
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: "JAN"
    }
  }, [_c("a-input", {
    attrs: {
      maxLength: 50,
      allowClear: true,
      placeholder: _vm.$t("public.enterPlease")
    },
    model: {
      value: _vm.formData.productBarcode,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "productBarcode", $$v);
      },
      expression: "formData.productBarcode"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 8
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("newProducDetail.sugestSell")
    }
  }, [_c("a-input-number", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      min: 0,
      allowClear: true,
      placeholder: _vm.$t("public.enterPlease"),
      max: 999999999
    },
    model: {
      value: _vm.formData.productPrice,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "productPrice", $$v);
      },
      expression: "formData.productPrice"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 8
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("newProducDetail.srx")
    }
  }, [_c("a-input", {
    attrs: {
      maxLength: 50,
      allowClear: true,
      disabled: true,
      placeholder: _vm.$t("newProducDetail.AutomaticMatching")
    },
    model: {
      value: _vm.formData.supplierName,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "supplierName", $$v);
      },
      expression: "formData.supplierName"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 8
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("newProducDetail.visitorVisible")
    }
  }, [_vm.formData.touristView == 0 ? [_vm.formData.touristViewJumpFlag ? _c("a", {
    on: {
      click: function click($event) {
        return _vm.gotoVisible({
          productNo: _vm.formData.productNo,
          id: _vm.productId
        });
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("newProducDetail.noVisible")))]) : _c("span", [_vm._v(_vm._s(_vm.$t("newProducDetail.noVisible")))])] : _c("span", [_vm._v(_vm._s(_vm.$t("newProducDetail.visible")))])], 2)], 1), _c("a-col", {
    attrs: {
      span: 8
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("newProducDetail.productBelong")
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      placeholder: _vm.$t("public.pleaseSelect")
    },
    model: {
      value: _vm.formData.productBelong,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "productBelong", $$v);
      },
      expression: "formData.productBelong"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: 0
    }
  }, [_vm._v(_vm._s(_vm.$t("newProducDetail.other")))]), _c("a-select-option", {
    attrs: {
      value: 1
    }
  }, [_vm._v(_vm._s(_vm.$t("newProducDetail.self")))])], 1)], 1)], 1)], 1), _c("footer-tool-bar", [_c("a-button", {
    attrs: {
      loading: _vm.queryLoading,
      type: "primary"
    },
    on: {
      click: _vm.save
    }
  }, [_vm._v(_vm._s(_vm.$t("public.save")))])], 1)], 1)], 1) : _vm._e()]), _vm.specFlag != 2 ? _c("div", [_c("a-card", {
    staticStyle: {
      "border-top": "24px solid #f0f2f5"
    },
    attrs: {
      bordered: false,
      title: _vm.$t("productDetail.productSpecs"),
      id: "sortDiv"
    }
  }, [_c("a-alert", {
    staticStyle: {
      "margin-bottom": "24px"
    },
    attrs: {
      message: _vm.$t("public.reminder"),
      description: _vm.$t("productDetail.tip"),
      type: "warning",
      "show-icon": "",
      closable: ""
    }
  }), _vm._l(_vm.specList, function (item, index) {
    return _c("div", {
      key: "specList" + index
    }, [_c("div", {
      staticStyle: {
        "background-color": "#f0f2f5",
        padding: "12px",
        display: "flex"
      }
    }, [_c("div", {
      staticStyle: {
        "padding-right": "12px"
      }
    }, [_vm._v(_vm._s(_vm.$t("productDetail.specsName")) + "：")]), _c("div", {
      staticStyle: {
        "padding-right": "20px",
        width: "200px"
      }
    }, [_vm._v(_vm._s(item.specName))]), _c("div", [_c("a", {
      on: {
        click: function click($event) {
          return _vm.getSpecName(item.specId);
        }
      }
    }, [_vm._v(_vm._s(_vm.$t("public.edit")))])])]), _c("div", {
      staticStyle: {
        display: "flex"
      }
    }, [_c("div", {
      staticStyle: {
        padding: "12px"
      }
    }, [_vm._v(_vm._s(_vm.$t("productDetail.specsValue")) + "：")]), item.specValueList.length == 0 ? _c("div", {
      staticStyle: {
        padding: "12px 0"
      }
    }, [_c("a", {
      on: {
        click: function click($event) {
          return _vm.addSpecValueModal(item.specId);
        }
      }
    }, [_vm._v(_vm._s(_vm.$t("productDetail.addSpecsValue")))])]) : _vm._e(), _c("div", {
      staticStyle: {
        "padding-right": "60px",
        "flex-direction": "column"
      },
      attrs: {
        id: "sort2"
      }
    }, _vm._l(item.specValueList, function (item2, index2) {
      return _c("div", {
        key: "specValueList" + item2.id,
        staticStyle: {
          padding: "12px 0"
        }
      }, [_c("span", {
        staticStyle: {
          "padding-right": "20px",
          width: "200px",
          display: "inline-block"
        }
      }, [_vm._v(_vm._s(item2.specValueName))]), _c("span", [_c("a", {
        on: {
          click: function click($event) {
            return _vm.editSpecValueBtn(item2.id);
          }
        }
      }, [_vm._v(_vm._s(_vm.$t("public.edit")))])]), _c("a-divider", {
        attrs: {
          type: "vertical"
        }
      }), _c("span", [_c("a-popconfirm", {
        attrs: {
          title: _vm.$t("public.deletePromp"),
          "ok-text": _vm.$t("public.confirm"),
          "cancel-text": _vm.$t("public.cancel")
        },
        on: {
          confirm: function confirm($event) {
            return _vm.deleteSpecValue(item2.id);
          }
        }
      }, [_c("a", [_vm._v(_vm._s(_vm.$t("public.delete")))])])], 1), item.specValueList.length - 1 == index2 ? _c("span", [_c("a-divider", {
        attrs: {
          type: "vertical"
        }
      }), _c("a", {
        on: {
          click: function click($event) {
            return _vm.addSpecValueModal(item.specId);
          }
        }
      }, [_vm._v(_vm._s(_vm.$t("productDetail.addSpecsValue")))])], 1) : _vm._e()], 1);
    }), 0)])]);
  })], 2), _c("a-modal", {
    attrs: {
      title: _vm.$t("productDetail.editSpecsName"),
      destroyOnClose: "",
      maskClosable: false
    },
    model: {
      value: _vm.visibleSpecName,
      callback: function callback($$v) {
        _vm.visibleSpecName = $$v;
      },
      expression: "visibleSpecName"
    }
  }, [_c("a-form-model", {
    ref: "specNameForm",
    attrs: {
      rules: _vm.rules,
      model: _vm.specNameDetailData
    }
  }, _vm._l(_vm.specNameDetailData.specNameDetail, function (tempObj, index) {
    return _c("div", {
      key: "specNameDetail" + index
    }, [tempObj.required ? [_c("a-form-model-item", {
      attrs: {
        label: tempObj.titleName,
        prop: "specNameDetail." + index + ".name",
        rules: [{
          required: true,
          message: _vm.specsNameErrTip,
          trigger: "blur"
        }]
      }
    }, [_c("a-input", {
      attrs: {
        allowClear: true,
        placeholder: _vm.$t("productDetail.pleaseInputSpecsName"),
        maxLength: 100
      },
      model: {
        value: tempObj.name,
        callback: function callback($$v) {
          _vm.$set(tempObj, "name", $$v);
        },
        expression: "tempObj.name"
      }
    })], 1)] : [_c("a-form-model-item", {
      attrs: {
        label: tempObj.titleName
      }
    }, [_c("a-input", {
      attrs: {
        allowClear: true,
        placeholder: _vm.$t("productDetail.pleaseInputSpecsName"),
        maxLength: 100
      },
      model: {
        value: tempObj.name,
        callback: function callback($$v) {
          _vm.$set(tempObj, "name", $$v);
        },
        expression: "tempObj.name"
      }
    })], 1)]], 2);
  }), 0), _c("template", {
    slot: "footer"
  }, [_c("a-button", {
    on: {
      click: function click($event) {
        return _vm.cancelPpdateSpecName();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("public.cancel")))]), _c("a-button", {
    attrs: {
      loading: _vm.updateLoadingN,
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.updateSpecName();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("public.confirm")))])], 1)], 2), _c("a-modal", {
    attrs: {
      title: _vm.textMap[_vm.dialogStatus],
      destroyOnClose: "",
      maskClosable: false
    },
    model: {
      value: _vm.visibleSpecValue,
      callback: function callback($$v) {
        _vm.visibleSpecValue = $$v;
      },
      expression: "visibleSpecValue"
    }
  }, [_c("a-form-model", {
    ref: "ruleForm",
    attrs: {
      rules: _vm.rules,
      model: _vm.specValueData
    }
  }, _vm._l(_vm.specValueData.nameList, function (tempObj, index) {
    return _c("div", {
      key: "nameList" + index
    }, [tempObj.required ? [_c("a-form-model-item", {
      attrs: {
        label: tempObj.titleName,
        prop: "nameList." + index + ".name",
        rules: [{
          required: true,
          message: _vm.specsValueErrTip,
          trigger: "blur"
        }]
      }
    }, [_c("a-input", {
      attrs: {
        allowClear: true,
        placeholder: _vm.$t("productDetail.pleaseInputSpecsValue"),
        maxLength: 100
      },
      model: {
        value: tempObj.name,
        callback: function callback($$v) {
          _vm.$set(tempObj, "name", $$v);
        },
        expression: "tempObj.name"
      }
    })], 1)] : [_c("a-form-model-item", {
      attrs: {
        label: tempObj.titleName
      }
    }, [_c("a-input", {
      attrs: {
        allowClear: true,
        placeholder: _vm.$t("productDetail.pleaseInputSpecsValue"),
        maxLength: 100
      },
      model: {
        value: tempObj.name,
        callback: function callback($$v) {
          _vm.$set(tempObj, "name", $$v);
        },
        expression: "tempObj.name"
      }
    })], 1)]], 2);
  }), 0), _c("template", {
    slot: "footer"
  }, [_c("a-button", {
    on: {
      click: function click($event) {
        return _vm.resetFormDate();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("public.cancel")))]), _vm.dialogStatus == "create" ? _c("a-button", {
    attrs: {
      loading: _vm.addLoadingV,
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.addSpecValue();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("public.confirm")))]) : _vm._e(), _vm.dialogStatus == "update" ? _c("a-button", {
    attrs: {
      loading: _vm.updateLoadingV,
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.updateSpecValue();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("public.confirm")))]) : _vm._e()], 1)], 2), _c("a-card", {
    attrs: {
      bordered: false
    }
  }, [_c("div", {
    staticStyle: {
      "margin-bottom": "8px",
      "background-color": "#f0f2f5",
      padding: "12px"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("productDetail.productSpecsDetail")) + " ")]), _c("div", {
    staticStyle: {
      "margin-bottom": "24px",
      "overflow-y": "hidden",
      "text-align": "end"
    }
  }, [_c("div", [_c("a-button", {
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      loading: _vm.queryLoading2,
      type: "primary"
    },
    on: {
      click: _vm.saveSpecsList
    }
  }, [_vm._v(_vm._s(_vm.$t("public.save")))])], 1), _c("div", [_c("a-table", {
    staticClass: "productSpecsDetail",
    staticStyle: {
      "overflow-y": "hidden"
    },
    attrs: {
      rowKey: "id",
      columns: _vm.productSpecsColumns,
      "data-source": _vm.specDetailList,
      bordered: "",
      pagination: false
    },
    scopedSlots: _vm._u([{
      key: "specName1",
      fn: function fn(text, record) {
        return [_vm._v(" " + _vm._s(record.specName1) + " "), _c("br"), record.touristView == 0 ? [record.touristViewJumpFlag ? _c("a", {
          staticStyle: {
            "text-decoration": "underline"
          },
          on: {
            click: function click($event) {
              return _vm.gotoVisible(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("newProducDetail.noVisible")))]) : _c("span", [_vm._v(_vm._s(_vm.$t("newProducDetail.noVisible")))])] : _c("span", [_vm._v(_vm._s(_vm.$t("newProducDetail.visible")))])];
      }
    }, {
      key: "productNo",
      fn: function fn(text, record, index) {
        return [_c("editable-cell", {
          attrs: {
            text: text,
            slotName: "productNo",
            errStatus: record.productNoError,
            errContent: _vm.errContent,
            disabled: _vm.noEditproductNo
          },
          on: {
            change: function change($event) {
              return _vm.onCellChange(record, "productNo", $event);
            }
          }
        })];
      }
    }, {
      key: "stockSyn",
      fn: function fn(text, record) {
        return [_c("editable-cell-select", {
          attrs: {
            text: text,
            slotName: "stockSyn",
            errStatus: false,
            selectList: _vm.stockSyncStatusList
          },
          on: {
            change: function change($event) {
              return _vm.onCellChange(record, "stockSyn", $event);
            }
          }
        })];
      }
    }, {
      key: "productSourceareaid",
      fn: function fn(text, record) {
        return [_c("a-select", _vm._b({
          staticStyle: {
            width: "100%"
          },
          attrs: {
            allowClear: ""
          },
          model: {
            value: record.productSourceareaid,
            callback: function callback($$v) {
              _vm.$set(record, "productSourceareaid", $$v);
            },
            expression: "record.productSourceareaid"
          }
        }, "a-select", _vm.$attrs, false), _vm._l(_vm.sourceareaList, function (item) {
          return _c("a-select-option", {
            key: item.id,
            staticStyle: {
              width: "100px"
            },
            attrs: {
              value: item.id,
              disabled: item.status != 1
            }
          }, [_vm._v(_vm._s(item.name))]);
        }), 1)];
      }
    }, {
      key: "productBrandid",
      fn: function fn(text, record) {
        return [_c("a-select", _vm._b({
          staticStyle: {
            width: "100%"
          },
          attrs: {
            showSearch: "",
            optionFilterProp: "children",
            allowClear: ""
          },
          model: {
            value: record.productBrandid,
            callback: function callback($$v) {
              _vm.$set(record, "productBrandid", $$v);
            },
            expression: "record.productBrandid"
          }
        }, "a-select", _vm.$attrs, false), _vm._l(_vm.brandList, function (item) {
          return _c("a-select-option", {
            key: item.id,
            staticStyle: {
              width: "100px"
            },
            attrs: {
              value: item.id,
              disabled: item.status != 1
            }
          }, [_vm._v(_vm._s(item.name))]);
        }), 1)];
      }
    }, {
      key: "productChannelid",
      fn: function fn(text, record) {
        return [_c("editable-cell-select", {
          attrs: {
            text: text,
            slotName: "productChannelid",
            errStatus: record.productChannelidErr,
            selectList: _vm.productChannelidList
          },
          on: {
            change: function change($event) {
              return _vm.onCellChange(record, "productChannelid", $event);
            }
          }
        })];
      }
    }, {
      key: "capacity",
      fn: function fn(text, record, index) {
        return [_c("editable-cell", {
          attrs: {
            text: text,
            slotName: "capacity",
            errStatus: record.productNoErr
          },
          on: {
            change: function change($event) {
              return _vm.onCellChange(record, "capacity", $event);
            }
          }
        })];
      }
    }, {
      key: "minOrderQuantity",
      fn: function fn(text, record) {
        return [_c("editable-cell-num", {
          ref: "minOrderQuantity",
          attrs: {
            text: text,
            slotName: "minOrderQuantity",
            align: "left",
            errStatus: false
          },
          on: {
            change: function change($event) {
              return _vm.onCellChange(record, "minOrderQuantity", $event);
            }
          }
        })];
      }
    }, {
      key: "productStocknum",
      fn: function fn(text, record) {
        return [_c("editable-cell-num", {
          ref: "productStocknum",
          attrs: {
            text: text,
            slotName: "productStocknum",
            align: "left",
            errStatus: record.productStocknumErr
          },
          on: {
            change: function change($event) {
              return _vm.onCellChange(record, "productStocknum", $event);
            }
          }
        })];
      }
    }, {
      key: "productPrice",
      fn: function fn(text, record) {
        return [_c("editable-cell-num", {
          attrs: {
            text: text,
            slotName: "productPrice",
            errStatus: false,
            align: "left"
          },
          on: {
            change: function change($event) {
              return _vm.onCellChange(record, "productPrice", $event);
            }
          }
        })];
      }
    }, {
      key: "productBelong",
      fn: function fn(text, record) {
        return [_c("a-select", _vm._b({
          staticStyle: {
            width: "100%"
          },
          attrs: {
            placeholder: _vm.$t("public.pleaseSelect")
          },
          model: {
            value: record.productBelong,
            callback: function callback($$v) {
              _vm.$set(record, "productBelong", $$v);
            },
            expression: "record.productBelong"
          }
        }, "a-select", _vm.$attrs, false), [_c("a-select-option", {
          attrs: {
            value: 0
          }
        }, [_vm._v(_vm._s(_vm.$t("newProducDetail.other")))]), _c("a-select-option", {
          attrs: {
            value: 1
          }
        }, [_vm._v(_vm._s(_vm.$t("newProducDetail.self")))])], 1)];
      }
    }, {
      key: "supplierName",
      fn: function fn(text, record) {
        return [_c("a-input", {
          attrs: {
            disabled: true,
            placeholder: _vm.$t("newProducDetail.AutomaticMatching")
          },
          model: {
            value: record.supplierName,
            callback: function callback($$v) {
              _vm.$set(record, "supplierName", $$v);
            },
            expression: "record.supplierName"
          }
        })];
      }
    }, {
      key: "caseOrItem",
      fn: function fn(text, record) {
        return [_c("editable-cell-select", {
          attrs: {
            placeholder: _vm.$t("public.pleaseSelect"),
            mode: "multiple",
            text: text,
            slotName: "caseOrItem",
            errStatus: record.caseOrItemError,
            selectList: _vm.caseOrItemList
          },
          on: {
            change: function change($event) {
              return _vm.onCellChange(record, "caseOrItem", $event);
            }
          }
        })];
      }
    }, {
      key: "caseQuantity",
      fn: function fn(text, record) {
        return [_c("editable-cell", {
          attrs: {
            text: text,
            slotName: "caseQuantity",
            errStatus: record.productSkunoErr
          },
          on: {
            change: function change($event) {
              return _vm.onCellChange(record, "caseQuantity", $event);
            }
          }
        })];
      }
    }, {
      key: "productLong",
      fn: function fn(text, record) {
        return [_c("editable-cell-num", {
          attrs: {
            text: text,
            slotName: "productLong",
            errStatus: false,
            align: "left"
          },
          on: {
            change: function change($event) {
              return _vm.onCellChange(record, "productLong", $event);
            }
          }
        })];
      }
    }, {
      key: "productWidth",
      fn: function fn(text, record) {
        return [_c("editable-cell-num", {
          attrs: {
            text: text,
            slotName: "productWidth",
            errStatus: false,
            align: "left"
          },
          on: {
            change: function change($event) {
              return _vm.onCellChange(record, "productWidth", $event);
            }
          }
        })];
      }
    }, {
      key: "productHeight",
      fn: function fn(text, record) {
        return [_c("editable-cell-num", {
          attrs: {
            text: text,
            slotName: "productHeight",
            errStatus: false,
            align: "left"
          },
          on: {
            change: function change($event) {
              return _vm.onCellChange(record, "productHeight", $event);
            }
          }
        })];
      }
    }, {
      key: "productWeight",
      fn: function fn(text, record) {
        return [_c("editable-cell-num", {
          attrs: {
            text: text,
            slotName: "productWeight",
            errStatus: false,
            align: "left"
          },
          on: {
            change: function change($event) {
              return _vm.onCellChange(record, "productWeight", $event);
            }
          }
        })];
      }
    }, {
      key: "productBarcode",
      fn: function fn(text, record, index) {
        return [_c("editable-cell", {
          attrs: {
            text: text,
            slotName: "productBarcode",
            errStatus: false
          },
          on: {
            change: function change($event) {
              return _vm.onCellChange(record, "productBarcode", $event);
            }
          }
        })];
      }
    }], null, false, 2788571620)
  }, [_vm.specList.length > 0 ? _c("template", {
    slot: "specName1Title"
  }, [_c("span", [_vm._v(_vm._s(_vm.specList[0].specName))]), _c("br"), _c("span", [_vm._v(_vm._s(_vm.$t("newProducDetail.visitorVisible")))])]) : _vm._e(), _c("span", {
    attrs: {
      slot: "productNoTitle"
    },
    slot: "productNoTitle"
  }, [_c("span", {
    staticStyle: {
      color: "#f5222d"
    }
  }, [_vm._v("*")]), _vm._v(" " + _vm._s(_vm.$t("productDetail.productNumber")) + " ")]), _c("span", {
    attrs: {
      slot: "stockSynTitle"
    },
    slot: "stockSynTitle"
  }, [_vm._v(" " + _vm._s(_vm.$t("productDetail.ERPstockSyncStatus")) + " "), _c("a-icon", {
    attrs: {
      type: "edit"
    },
    on: {
      click: function click($event) {
        return _vm.showModal("stockSyn");
      }
    }
  })], 1), _c("span", {
    attrs: {
      slot: "productChannelidTitle"
    },
    slot: "productChannelidTitle"
  }, [_c("span", {
    staticStyle: {
      color: "#f5222d"
    }
  }, [_vm._v("*")]), _vm._v(" " + _vm._s(_vm.$t("productDetail.deliveryChannel")) + " "), _c("a-icon", {
    attrs: {
      type: "edit"
    },
    on: {
      click: function click($event) {
        return _vm.showModal("productChannelid");
      }
    }
  })], 1), _c("span", {
    attrs: {
      slot: "capacityTitle"
    },
    slot: "capacityTitle"
  }, [_vm._v(" " + _vm._s(_vm.$t("newProducDetail.capacity")) + " ")]), _c("span", {
    attrs: {
      slot: "minOrderQuantityTitle"
    },
    slot: "minOrderQuantityTitle"
  }, [_vm._v(" " + _vm._s(_vm.$t("newProducDetail.minCount")) + " ")]), _c("span", {
    attrs: {
      slot: "productStocknumTitle"
    },
    slot: "productStocknumTitle"
  }, [_c("span", {
    staticStyle: {
      color: "#f5222d"
    }
  }, [_vm._v("*")]), _vm._v(" " + _vm._s(_vm.$t("productDetail.stockNum")) + " "), _c("a-icon", {
    attrs: {
      type: "edit"
    },
    on: {
      click: function click($event) {
        return _vm.showModal("productStocknum");
      }
    }
  })], 1), _c("span", {
    attrs: {
      slot: "productPriceTitle"
    },
    slot: "productPriceTitle"
  }, [_vm._v(" " + _vm._s(_vm.$t("newProducDetail.sugestSell")) + " "), _c("a-icon", {
    attrs: {
      type: "edit"
    },
    on: {
      click: function click($event) {
        return _vm.showModal("productPrice");
      }
    }
  })], 1), _c("span", {
    attrs: {
      slot: "productBelongTitle"
    },
    slot: "productBelongTitle"
  }, [_vm._v(" " + _vm._s(_vm.$t("newProducDetail.productBelong")) + " ")]), _c("span", {
    attrs: {
      slot: "supplierNameTitle"
    },
    slot: "supplierNameTitle"
  }, [_vm._v(" " + _vm._s(_vm.$t("newProducDetail.srx")) + " ")]), _c("span", {
    attrs: {
      slot: "caseOrItemTitle"
    },
    slot: "caseOrItemTitle"
  }, [_c("span", {
    staticStyle: {
      color: "#f5222d"
    }
  }, [_vm._v("*")]), _vm._v(" " + _vm._s(_vm.$t("newProducDetail.sellWay")) + " ")]), _c("span", {
    attrs: {
      slot: "caseQuantityTitle"
    },
    slot: "caseQuantityTitle"
  }, [_vm._v(" " + _vm._s(_vm.$t("newProducDetail.rushu")) + " ")]), _c("span", {
    attrs: {
      slot: "productLongTitle"
    },
    slot: "productLongTitle"
  }, [_vm._v(" " + _vm._s(_vm.$t("productDetail.long")) + " "), _c("a-icon", {
    attrs: {
      type: "edit"
    },
    on: {
      click: function click($event) {
        return _vm.showModal("productLong");
      }
    }
  })], 1), _c("span", {
    attrs: {
      slot: "productWidthTitle"
    },
    slot: "productWidthTitle"
  }, [_vm._v(" " + _vm._s(_vm.$t("productDetail.width")) + " "), _c("a-icon", {
    attrs: {
      type: "edit"
    },
    on: {
      click: function click($event) {
        return _vm.showModal("productWidth");
      }
    }
  })], 1), _c("span", {
    attrs: {
      slot: "productHeightTitle"
    },
    slot: "productHeightTitle"
  }, [_vm._v(" " + _vm._s(_vm.$t("productDetail.height")) + " "), _c("a-icon", {
    attrs: {
      type: "edit"
    },
    on: {
      click: function click($event) {
        return _vm.showModal("productHeight");
      }
    }
  })], 1), _c("span", {
    attrs: {
      slot: "productWeightTitle"
    },
    slot: "productWeightTitle"
  }, [_vm._v(" " + _vm._s(_vm.$t("productDetail.weight")) + " "), _c("a-icon", {
    attrs: {
      type: "edit"
    },
    on: {
      click: function click($event) {
        return _vm.showModal("productWeight");
      }
    }
  })], 1), _c("span", {
    attrs: {
      slot: "productBarcodeTitle"
    },
    slot: "productBarcodeTitle"
  }, [_vm._v(" " + _vm._s("JAN") + " ")])], 2)], 1)])]), _c("a-card", {
    staticStyle: {
      "border-top": "24px solid #f0f2f5"
    },
    attrs: {
      title: _vm.$t("productDetail.other"),
      bordered: false
    }
  }, [_c("a-form-model", {
    ref: "formData2",
    staticClass: "form2",
    attrs: {
      model: _vm.form2Data,
      rules: _vm.rules
    }
  }, [_c("a-row", {
    staticClass: "formRow",
    attrs: {
      gutter: 128
    }
  }, [_c("a-col", {
    attrs: {
      span: 8
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("productDetail.choiceDays"),
      prop: "daysOfStock"
    }
  }, [_c("a-input-number", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      allowClear: true,
      placeholder: _vm.$t("public.enterPlease"),
      max: 999
    },
    model: {
      value: _vm.form2Data.daysOfStock,
      callback: function callback($$v) {
        _vm.$set(_vm.form2Data, "daysOfStock", $$v);
      },
      expression: "form2Data.daysOfStock"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 8
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("productDetail.expressWayPrimary"),
      prop: "transportFirstId"
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      placeholder: _vm.$t("public.pleaseSelect")
    },
    model: {
      value: _vm.form2Data.transportFirstId,
      callback: function callback($$v) {
        _vm.$set(_vm.form2Data, "transportFirstId", $$v);
      },
      expression: "form2Data.transportFirstId"
    }
  }, _vm._l(_vm.transportList, function (item) {
    return _c("a-select-option", {
      key: item.id,
      attrs: {
        value: item.id
      }
    }, [_vm._v(_vm._s(item.name))]);
  }), 1)], 1)], 1), void 0], 2), _c("a-row", [_c("a-col", {
    attrs: {
      span: 24
    }
  }, [_c("a-form-model-item", {
    staticStyle: {
      "text-align": "end"
    },
    attrs: {
      label: " ",
      colon: false
    }
  }, [_c("a-button", {
    attrs: {
      type: "primary",
      loading: _vm.save2Loading
    },
    on: {
      click: _vm.save2
    }
  }, [_vm._v(_vm._s(_vm.$t("public.save")))])], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e(), _c("a-modal", {
    attrs: {
      title: _vm.$t("productDetail.batchEdit"),
      visible: _vm.visibleBatch,
      "confirm-loading": _vm.confirmLoading,
      maskClosable: false
    },
    on: {
      cancel: _vm.handleCancel
    }
  }, [_c("a-form-model", {
    ref: "dataForm",
    attrs: {
      model: _vm.editproductSpecsObj
    }
  }, [_vm.modelInputStaus == "productNo" ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("productDetail.productNumber")
    }
  }, [_c("a-input", {
    attrs: {
      allowClear: true,
      placeholder: _vm.$t("public.enterPlease"),
      maxLength: 100
    },
    model: {
      value: _vm.editproductSpecsObj.productNo,
      callback: function callback($$v) {
        _vm.$set(_vm.editproductSpecsObj, "productNo", $$v);
      },
      expression: "editproductSpecsObj.productNo"
    }
  })], 1) : _vm._e(), _vm.modelInputStaus == "productBarcode" ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("productDetail.barcode")
    }
  }, [_c("a-input", {
    attrs: {
      allowClear: true,
      placeholder: _vm.$t("public.enterPlease"),
      maxLength: 100
    },
    model: {
      value: _vm.editproductSpecsObj.productBarcode,
      callback: function callback($$v) {
        _vm.$set(_vm.editproductSpecsObj, "productBarcode", $$v);
      },
      expression: "editproductSpecsObj.productBarcode"
    }
  })], 1) : _vm._e(), _vm.modelInputStaus == "productStocknum" ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("productDetail.stockNum")
    }
  }, [_c("a-input-number", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      allowClear: true,
      placeholder: _vm.$t("public.enterPlease"),
      min: 0,
      max: 99999999
    },
    model: {
      value: _vm.editproductSpecsObj.productStocknum,
      callback: function callback($$v) {
        _vm.$set(_vm.editproductSpecsObj, "productStocknum", $$v);
      },
      expression: "editproductSpecsObj.productStocknum"
    }
  })], 1) : _vm._e(), _vm.modelInputStaus == "productPrice" ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("newProducDetail.sugestSell2")
    }
  }, [_c("a-input-number", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      allowClear: true,
      placeholder: _vm.$t("public.enterPlease"),
      min: 0,
      max: 99999999
    },
    model: {
      value: _vm.editproductSpecsObj.productPrice,
      callback: function callback($$v) {
        _vm.$set(_vm.editproductSpecsObj, "productPrice", $$v);
      },
      expression: "editproductSpecsObj.productPrice"
    }
  })], 1) : _vm._e(), _vm.modelInputStaus == "productChannelid" ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("productDetail.deliveryChannel")
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("public.pleaseSelect"),
      allowClear: ""
    },
    model: {
      value: _vm.editproductSpecsObj.productChannelid,
      callback: function callback($$v) {
        _vm.$set(_vm.editproductSpecsObj, "productChannelid", $$v);
      },
      expression: "editproductSpecsObj.productChannelid"
    }
  }, _vm._l(_vm.productChannelidList, function (item) {
    return _c("a-select-option", {
      key: item.id,
      attrs: {
        value: item.id,
        disabled: item.status != 1
      }
    }, [_vm._v(_vm._s(item.name))]);
  }), 1)], 1) : _vm._e(), _vm.modelInputStaus == "stockSyn" ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("productDetail.ERPstockSyncStatus")
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("public.pleaseSelect"),
      allowClear: ""
    },
    model: {
      value: _vm.editproductSpecsObj.stockSyn,
      callback: function callback($$v) {
        _vm.$set(_vm.editproductSpecsObj, "stockSyn", $$v);
      },
      expression: "editproductSpecsObj.stockSyn"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: "0"
    }
  }, [_vm._v(_vm._s(_vm.$t("public.yes")))]), _c("a-select-option", {
    attrs: {
      value: "1"
    }
  }, [_vm._v(_vm._s(_vm.$t("public.no")))])], 1)], 1) : _vm._e(), _vm.modelInputStaus == "productSkuno" ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("productDetail.sku")
    }
  }, [_c("a-input", {
    attrs: {
      allowClear: true,
      placeholder: _vm.$t("public.enterPlease"),
      maxLength: 100
    },
    model: {
      value: _vm.editproductSpecsObj.productSkuno,
      callback: function callback($$v) {
        _vm.$set(_vm.editproductSpecsObj, "productSkuno", $$v);
      },
      expression: "editproductSpecsObj.productSkuno"
    }
  })], 1) : _vm._e(), _vm.modelInputStaus == "freightMode" ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("productDetail.freightMode")
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("public.pleaseSelect"),
      allowClear: ""
    },
    model: {
      value: _vm.editproductSpecsObj.freightMode,
      callback: function callback($$v) {
        _vm.$set(_vm.editproductSpecsObj, "freightMode", $$v);
      },
      expression: "editproductSpecsObj.freightMode"
    }
  }, _vm._l(_vm.freightModeList, function (item) {
    return _c("a-select-option", {
      key: item.id,
      attrs: {
        value: item.id
      }
    }, [_vm._v(_vm._s(item.name))]);
  }), 1)], 1) : _vm._e(), _vm.modelInputStaus == "productLong" ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("productDetail.long")
    }
  }, [_c("a-input-number", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      allowClear: true,
      placeholder: _vm.$t("public.enterPlease"),
      min: 0,
      max: 99999999
    },
    model: {
      value: _vm.editproductSpecsObj.productLong,
      callback: function callback($$v) {
        _vm.$set(_vm.editproductSpecsObj, "productLong", $$v);
      },
      expression: "editproductSpecsObj.productLong"
    }
  })], 1) : _vm._e(), _vm.modelInputStaus == "productWidth" ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("productDetail.width")
    }
  }, [_c("a-input-number", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      allowClear: true,
      placeholder: _vm.$t("public.enterPlease"),
      min: 0,
      max: 99999999
    },
    model: {
      value: _vm.editproductSpecsObj.productWidth,
      callback: function callback($$v) {
        _vm.$set(_vm.editproductSpecsObj, "productWidth", $$v);
      },
      expression: "editproductSpecsObj.productWidth"
    }
  })], 1) : _vm._e(), _vm.modelInputStaus == "productHeight" ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("productDetail.height")
    }
  }, [_c("a-input-number", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      allowClear: true,
      placeholder: _vm.$t("public.enterPlease"),
      min: 0,
      max: 99999999
    },
    model: {
      value: _vm.editproductSpecsObj.productHeight,
      callback: function callback($$v) {
        _vm.$set(_vm.editproductSpecsObj, "productHeight", $$v);
      },
      expression: "editproductSpecsObj.productHeight"
    }
  })], 1) : _vm._e(), _vm.modelInputStaus == "productWeight" ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("productDetail.weight")
    }
  }, [_c("a-input-number", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      allowClear: true,
      placeholder: _vm.$t("public.enterPlease"),
      min: 0,
      max: 99999999
    },
    model: {
      value: _vm.editproductSpecsObj.productWeight,
      callback: function callback($$v) {
        _vm.$set(_vm.editproductSpecsObj, "productWeight", $$v);
      },
      expression: "editproductSpecsObj.productWeight"
    }
  })], 1) : _vm._e()], 1), _c("template", {
    slot: "footer"
  }, [_c("a-button", {
    on: {
      click: _vm.handleCancel
    }
  }, [_vm._v(_vm._s(_vm.$t("public.cancel")))]), _c("a-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.handleOk
    }
  }, [_vm._v(_vm._s(_vm.$t("public.confirm")))])], 1)], 2)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };